<ng-container>
  <ion-toolbar class="ion-no-padding full-height">
    <ion-grid class="ion-no-padding">
      <ion-row class="ion-no-padding">
        <ion-col size="12/5">
          @if (isOnHomePage()) {
            <div class="current-page-indicator"></div>
          }
        </ion-col>
        <ion-col size="12/5">
          @if (isOnMyCloset()) {
            <div class="current-page-indicator"></div>
          }
        </ion-col>
        <ion-col size="12/5">
          @if (isOnDeliveries()) {
            <div class="current-page-indicator"></div>
          }
        </ion-col>
        <ion-col size="12/5">
          @if (isOnRewards()) {
            <div class="current-page-indicator"></div>
          }
        </ion-col>
        <ion-col size="12/5">
          @if (isOnAccount()) {
            <div class="current-page-indicator"></div>
          }
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-buttons>
      <ion-button class="disable-default-style" (click)="navigationService.goToHomePage()">
        <div class="footer-button">
          <ion-icon name="home" color="light"></ion-icon>
          <ion-label color="light">Home</ion-label>
        </div>
      </ion-button>
      <ion-button class="disable-default-style" (click)="navigationService.goToMyClosetPage()">
        <div class="footer-button">
          <ion-icon name="cube" color="light"></ion-icon>
          <ion-label color="light">My Closet</ion-label>
        </div>
      </ion-button>
      <ion-button class="disable-default-style" (click)="navigationService.goToDeliveriesPage()">
        <div class="footer-button">
          <ion-icon name="car" color="light"></ion-icon>
          <ion-label color="light">Deliveries</ion-label>
        </div>
      </ion-button>
      <ion-button class="disable-default-style" (click)="navigationService.goToRewardsPage()">
        <div class="footer-button">
          <ion-icon name="ribbon-outline" color="light"></ion-icon>
          <ion-label color="light">Rewards</ion-label>
        </div>
      </ion-button>
      <ion-button class="disable-default-style" (click)="navigationService.goToMyAccountPage()">
        <div class="footer-button">
          <ion-icon name="person" color="light"></ion-icon>
          <ion-label color="light">Account</ion-label>
        </div>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ng-container>
